import "../lib/public_path";

// Import jQuery and set it globally
import $ from "jquery";
window.$ = window.jQuery = $;

// Import jquery-ujs and initialize it
import "jquery-ujs";

// Import jquery-ui
import "jquery-ui-dist";

// Import datepicker locales
import "../lib/websites/scripts/jquery.ui.datepicker-ca";
import "../lib/websites/scripts/jquery.ui.datepicker-de";
import "../lib/websites/scripts/jquery.ui.datepicker-el";
import "../lib/websites/scripts/jquery.ui.datepicker-es";
import "../lib/websites/scripts/jquery.ui.datepicker-fr";
import "../lib/websites/scripts/jquery.ui.datepicker-hr";
import "../lib/websites/scripts/jquery.ui.datepicker-it";
import "../lib/websites/scripts/jquery.ui.datepicker-nl";
import "../lib/websites/scripts/jquery.ui.datepicker-pl";
import "../lib/websites/scripts/jquery.ui.datepicker-pt";
import "../lib/websites/scripts/jquery.ui.datepicker-pt-BR";
import "../lib/websites/scripts/jquery.ui.datepicker-ru";
import "../lib/websites/scripts/jquery.ui.datepicker-zh-CN";

// Import cloudinary
import "cloudinary-jquery";

// Import fullcalendar
import { Calendar } from "fullcalendar";
window.FullCalendar = Calendar;

// Import aos
import AOS from "aos";
window.AOS = AOS;

// Import moment
import moment from "moment";
window.moment = moment;

// Import daterangepicker
import "../lib/websites/jquery.daterangepicker";

// Import slick-carousel
import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "../stylesheets/tailwind.style.css";

// Import amenitiz
import "../lib/websites/amenitiz";
$($ => {
  $("a").tooltip();
});
$.htmlPrefilter = html => html;